import React from 'react'
import PropTypes from 'prop-types'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { Brand, BrandLink, Root, Row } from './HeaderSection.styles'

/**
 * The HeaderSection's container.
 */
const HeaderSection = ({ align, brandMargin, brandSize }) => {
  const handleClickDeskLink = () => {
    window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`, '_top')
  }

  return (
    <Root>
      <Row align={align}>
        <BrandLink to="#" onClick={handleClickDeskLink}>
          <Brand alt="Mercado Público" margin={brandMargin} size={brandSize} src="/assets/images/logo_brand.svg" />
        </BrandLink>
      </Row>
    </Root>
  )
}

HeaderSection.defaultProps = {
  align: 'left',
  brandMargin: '0 57px 0 0',
  brandSize: 'small'
}
HeaderSection.propTypes = {
  align: PropTypes.oneOf(['center', 'left', 'right']),
  brandMargin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  brandSize: PropTypes.oneOf(['small', 'medium'])
}

export default HeaderSection
